import { useDialog } from "@/hooks/useDialog";
import { CreateWorkspaceDialog } from "@/components/workspaces/CreateWorkspaceDialog";

interface DialogProps {
  params: Record<string, string>;
  onClose: () => void;
}

const dialogRegistry: Record<string, React.ComponentType<DialogProps>> = {
  "create-workspace": CreateWorkspaceDialog,
  // Future dialogs added here
};

export function DialogRouter() {
  const { dialogId, dialogParams, closeDialog } = useDialog();

  if (!dialogId) return null;

  const DialogComponent = dialogRegistry[dialogId];
  if (!DialogComponent) return null;

  return <DialogComponent params={dialogParams} onClose={closeDialog} />;
}
